import { KYMW4700Component } from './kymw4700.component';
import { KYMW0300InputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { GetMultiCodeListResponse } from './api-services/get-multi-code-list.service';

/**
 * マルチコード一覧画面の値を管理するクラス
 *
 * @export KYMW4700Model
 * @class KYMW4700Model
 */
export class KYMW4700Model {
  public kymw4700Component: KYMW4700Component;

  // マルチコード一覧の総件数
  public totalNum = 0;
  // マルチコード一覧の開始件数
  public startDispNum = 0;
  // マルチコード一覧の終了件数
  public endDispNum = 0;
  // マルチコード一覧データ
  public multiCodeList: GetMultiCodeListResponse['MultiCodeList'] = [];
  // マルチコード一覧の現在ページ
  public pageNum = 1;
  // APIリクエスト ページ
  public reqPageNum = 1;

  public dataKbnFlg = '';

  public kymw0300input: KYMW0300InputModel = new KYMW0300InputModel();
  public kymw0300output: KYMW0300OutputModel = new KYMW0300OutputModel();

  /**
   * 商品検索結果の画面反映
   */
  public setSearchResult(serverData: GetMultiCodeListResponse): void {
    // ページング関連項目初期化
    this.multiCodeList = serverData.MultiCodeList;
    const total = Number(serverData.TotalNum);
    this.totalNum = Number.isNaN(total) ? 0 : total;
    const start = Number(serverData.StartDispNum);
    this.startDispNum = Number.isNaN(start) ? 0 : start;
    const end = Number(serverData.EndDispNum);
    this.endDispNum = Number.isNaN(end) ? 0 : end;

    // グリッドの更新
    this.kymw4700Component.dtg_MultiCodeList.collectionView.refresh();
  }

  get nextDisabled() {
    return !(this.endDispNum < this.totalNum);
  }

  get prevDisabled() {
    return this.startDispNum < 2;
  }
}
